import classNames from 'classnames';
import React from 'react';
import { showConfirmationDialog } from '../Modal/ConfirmationDialog';
import Text from '../Text';
import { textLinkVariantClassnames } from '../TextLink';

/**
 * Warns a user whose legacy Spec ID data sits in an unlocked year that the upgrade will not carry it
 * over, and asks whether to continue anyway.
 *
 * `showConfirmationDialog`'s own promise only settles on confirm, so the outcome is read off the
 * callbacks instead. `onConfirm` runs before `onClose`, and the cancel button runs `onClose` before
 * `onCancel`, so the first `resolve` always wins and the second is a no-op. `onClose` also covers
 * ESC and backdrop dismissal, both of which count as "Not now".
 */
export default function confirmSpecIdMigration(): Promise<boolean> {
  return new Promise((resolve) => {
    void showConfirmationDialog({
      title: 'Spec ID data needs manual migration',
      showCloseIcon: false,
      content: () => (
        <Text as="p" variant="base" className="mb-6">
          Your account has Spec ID data that needs to be migrated manually. Please reach out to{' '}
          <a className={classNames(textLinkVariantClassnames.primary)} href="mailto:support@tokentax.co">
            support@tokentax.co
          </a>{' '}
          and we will help resolve.
          <br />
          <br />
          If you continue, your legacy Spec ID data will be lost.
        </Text>
      ),
      buttonText: 'Continue upgrade',
      cancelButtonText: 'Not now',
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      onClose: () => resolve(false),
    });
  });
}
